import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_select",
  "use": "icon-icon_select-usage",
  "viewBox": "0 0 12 6",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 12 6\" id=\"icon-icon_select\">\n  <image id=\"icon-icon_select__4\" data-name=\"4\" width=\"12\" height=\"6\" xlink:href=\"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAGCAYAAAD37n+BAAAAN0lEQVQYlWPcvXv3fwYSACNIKbGaXF1dGcEaiNEEUgyi4RrwaYIpxtCATROyYpwApAmrbQwMDADW4xmW1kG1GQAAAABJRU5ErkJggg==\"></image>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol